import React from 'react';
import styles from '../styles/polaroid.module.css';

const Polaroid = ({...props}) => {
    return (
        <div className={styles.card}>
            <div className={styles.picture}>
            <img src={props.src} alt={props.caption} />
            </div>
            <span className={styles.caption}>{props.caption}</span>
        </div>
    )
};
  
export default Polaroid;